import script from "./SelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=ad34c48e&lang=css"

const __exports__ = script;

export default __exports__